import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\UndoDeleteMediaController::__invoke
* @see app/Http/Controllers/ElectronicSignature/UndoDeleteMediaController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}/undo-delete'
*/
const UndoDeleteMediaController = (args: { electronicSignature: string | number | { id: string | number }, media: string | number } | [electronicSignature: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UndoDeleteMediaController.url(args, options),
    method: 'get',
})

UndoDeleteMediaController.definition = {
    methods: ["get","head"],
    url: '/api/electronic-signature/{electronicSignature}/media/{media}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\UndoDeleteMediaController::__invoke
* @see app/Http/Controllers/ElectronicSignature/UndoDeleteMediaController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}/undo-delete'
*/
UndoDeleteMediaController.url = (args: { electronicSignature: string | number | { id: string | number }, media: string | number } | [electronicSignature: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
        media: args.media,
    }

    return UndoDeleteMediaController.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\UndoDeleteMediaController::__invoke
* @see app/Http/Controllers/ElectronicSignature/UndoDeleteMediaController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}/undo-delete'
*/
UndoDeleteMediaController.get = (args: { electronicSignature: string | number | { id: string | number }, media: string | number } | [electronicSignature: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: UndoDeleteMediaController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ElectronicSignature\UndoDeleteMediaController::__invoke
* @see app/Http/Controllers/ElectronicSignature/UndoDeleteMediaController.php
* @route '/api/electronic-signature/{electronicSignature}/media/{media}/undo-delete'
*/
UndoDeleteMediaController.head = (args: { electronicSignature: string | number | { id: string | number }, media: string | number } | [electronicSignature: string | number | { id: string | number }, media: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: UndoDeleteMediaController.url(args, options),
    method: 'head',
})

export default UndoDeleteMediaController